import { gql } from '@apollo/client';

export interface DspTaskIdsByStatusResult {
    inProgressDspTaskIds: number[];
    publishSuccessDspTaskIds: number[];
    publishFailedDspTaskIds: number[];
}

export interface GroupDspTaskIdsByStatusResponse {
    groupDspTaskIdsByStatus: DspTaskIdsByStatusResult;
}

export interface GroupDspTaskIdsByStatusVariables {
    dspTaskIds: number[];
}

export const GROUP_DSP_TASK_IDS_BY_STATUS = gql`
    query GroupDspTaskIdsByStatus($dspTaskIds: [Long!]!) {
        groupDspTaskIdsByStatus(dspTaskIds: $dspTaskIds) {
            inProgressDspTaskIds
            publishSuccessDspTaskIds
            publishFailedDspTaskIds
        }
    }
`;
